function getQueryParameter(key) {
  let params = getParams(window.location.href)

  return params[key]
}

function capitalise(str) {
  str = str.split(' ')

  for (var i = 0, x = str.length; i < x; i++) {
    str[i] = str[i][0].toUpperCase() + str[i].substr(1)
  }

  return str.join(' ')
}

// function generateRandomString(length, ...ranges) {
//   // https://stackoverflow.com/questions/43547777/how-to-create-a-random-string-from-a-regular-expression
//   let randStr = ''
//   while (length--) {
//     const ind = Math.floor(Math.random() * ranges.length)
//     const min = ranges[ind][0].charCodeAt(0),
//       max = ranges[ind][1].charCodeAt(0)
//     const c = Math.floor(Math.random() * (max - min + 1)) + min
//     randStr += String.fromCharCode(c)
//   }
//   return randStr
// }

// function genId() {
//   return generateRandomString(10, ['0', '9'])
// }

function checkIfAllCharactersAreCreated() {
  const productConfig = window.store.get('productConfig')
  let charactersRequired = productConfig
    ? productConfig.characters
    : ['character1']
  if (!productConfig) {
    console.log(
      '%c Product config not found, comparing against one character only',
      'color: #FFFF00;'
    )
  }
  if (
    document.querySelectorAll('input[name^="properties[__character_character"]')
      .length >= charactersRequired.length
  ) {
    $('#add-to-cart').removeAttr('disabled')
    $('#add-to-group').removeAttr('disabled')
    trackAnalytics('Product Page', 'Finish Character')
  } else {
    $('#add-to-cart').attr('disabled', true)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  let loggedIn = ShopifyAnalytics.meta.page.customerId
  let hasSavedCharacters = window.sessionStorage.getItem('savedCharacters')

  fetchCart().then((data) => {
    localStorage.setItem('cart', JSON.stringify(data))

    // If not logged in and have no characters stored in session
    if (!loggedIn && !hasSavedCharacters) {
      // Get all item characters from cart items and save them to character storage (savedCharacters in sessionStorage)
      data.items.forEach((item) => {
        let itemConfig = JSON.parse(item.properties.__midnight_config)

        Object.keys(itemConfig).forEach((key) => {
          // Create character string
          let pose_id = window.store.get('pose_id') || 'PZ001'
          let document_id = window.store.get('document_id') || 'DC001'
          let context_id = window.store.get('context_id') || 'CX001'
          let character_string = [
            itemConfig[key].image,
            pose_id,
            document_id,
            context_id,
          ].join('_')

          characterStorage.storeCharacter(
            character_string,
            itemConfig[key].brand,
            '',
            'web'
          )
        })
      })
    }
  })

  const bodyClasses = [...document.body.classList] // DOMTokenList => array

  // If body has any of these classes init builder
  if (
    bodyClasses.filter((val) =>
      ['template-account', 'template-page', 'template-product'].includes(val)
    )
  ) {
    toxicFoxBuilder.init()
  }

  if (bodyClasses.includes('template-product')) {
    characterStorage.setup(window.store.get('brand'))
    trackAnalytics('Product Page', 'Page Load')
  }

  document.onkeydown = function (evt) {
    evt = evt || window.event
    var isEscape = false
    if ('key' in evt) {
      isEscape = evt.key === 'Escape' || evt.key === 'Esc'
    } else {
      isEscape = evt.keyCode === 27
    }
    if (isEscape) {
      closeMoonshineDialog()
    }
  }

  //ADD TO CART EVENT
  if (document.getElementById('add-to-cart')) {
    document
      .getElementById('add-to-cart')
      .addEventListener('click', function () {
        //these will need to get the product config
        let config = JSON.parse(
          document.getElementById('moonshine_config_json').innerHTML
        )
        let characterString = getCurrentCharacterString()
        if (!characterString) return

        // Get midnight config element that holds the character values
        let midnightConfig = JSON.parse(
          document.getElementById('__midnight_config-0-0').value || null
        )

        // Get characters array, store each character
        for (key in midnightConfig) {
          const character = midnightConfig[key]

          characterStorage.storeCharacter(
            generateCharacterString(character.image),
            character.brand,
            null,
            'web'
          )
        }

        if (config.hasOwnProperty('parts')) return

        //if multiple character the brand will not be available
        //characterStorage.storeCharacter(characterString, config.brand, config.sub_brand, 'web')

        // Add characters to customer metafields
        if (loggedIn) {
          let data = {
            characterData: characterStorage.getCharacters(),
            customer: loggedIn,
          }
          $.ajax({
            url: 'https://p0ng8n4561.execute-api.eu-west-1.amazonaws.com/production/update',
            crossDomain: true,
            data: JSON.stringify(data),
            method: 'POST',
          }).then(function (response) {})
        }
      })
  }

  if (document.getElementById('update')) {
    document.getElementById('update').addEventListener('click', function () {
      
      const nodes = Array.from(document.getElementsByClassName('spb-productoptionbackground'))

      let formData = new FormData(document.querySelector('.product-form'))

      nodes.forEach((node) => {
        formData.set(node.key, node.value)
      })

      //   formData.append('quantity', document.getElementById('Quantity').value)
      //   formData.set('line', line_item)

      // characterStorage.storeCharacter(imageParams, window.store.get('brand'))

      //log
      //for (var key of formData.entries()) {console.log(key[0]+','+key[1])}

      //remove the original item, then add the new one
      $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        data: {
          line: localStorage.getItem('lineItemId'),
          quantity: 0,
        },
        complete: function (data) {
          add_updated_item(formData)
        },
      })
    })
  }

  window.addEventListener('message', function (event) {
    if (event.data.hasOwnProperty('event')) {
      // console.log(event.data.event)
      switch (event.data.event) {
        case 'create':
          // console.log("%c 👻 'create' fired!", 'color: #d78521;')
          let data = event.data.data
          //build the configuration object to be store in the midnight config field
          let character = buildMidnightConfigurationObject(data.brand)

          // console.log("create: character",character)

          characterStorage.storeCharacter(
            generateCharacterString(character.image),
            character.brand,
            null,
            'web'
          )

          toggleBuilderWindow('none')
          $('.breadcrumbs').css('z-index', 2)
          $('.site-header').css('z-index', '')
          $('body').css('overflow', 'visible')
          //resync and redirect

          window.dispatchEvent(new CustomEvent('resync'))

          break
        case 'done':
          // console.log("%c 👻 'done' fired!", 'color: #d78521;')
          // characterStorage.initialiseCharacter()
          // document.querySelector('#saved-characters').disabled = false
          // const savedCharsBtn = document.querySelector('#saved-characters')
          // savedCharsBtn.disabled = false
          // savedCharsBtn.innerHTML = 'Your Characters'
          break
        case 'ga_event':
          trackAnalytics(event.data.action, event.data.label)
          break
        case 'request':
          // console.log(
          //   "%c 👻 'request' fired! key: " + event.data.key,
          //   'color: #d78521;'
          // )
          // dispatch the requested key with its value to the builder
          let contentWindow = document.getElementById('builder').contentWindow
          contentWindow.postMessage(
            {
              event: 'set',
              key: event.data.key,
              value: window.store.get(event.data.key),
            },
            '*'
          )
          break
        case 'close':
          // console.log("%c 👻 'close' fired!", 'color: #d78521;')
          $('html, body').removeClass('noScroll')
          // window.scrollTo(0, window.windowScrollPosition)
          document.scrollingElement.scrollTop = window.windowScrollPosition
          toggleBuilderWindow('none')
          $('.breadcrumbs').css('z-index', 2)
          $('.site-header').css('z-index', '')
          $('body').css('overflow', 'visible')
          ga('send', 'event', 'Product Page', 'Cancel Builder') //GA tracking
          break
        case 'store':
          // console.log("%c 👻 'store' fired!", 'color: #d78521;')
          // console.log('event data:', event.data.data)

          //when a character is stored, we need to store the brand
          //store selection in storage for multiple characters
          //get character key
          let { key, brand } = event.data.data

          // Build the configuration object to be stores in the midnight config field
          let obj = buildMidnightConfigurationObject(brand, key)

          // Get hidden midnight config element
          let midnightConfig = document.getElementsByName(
            'properties[__midnight_config]'
          )[0]
          // let midnightConfig = document.querySelector(
          //   '[name="properties[__midnight_config]"'
          // )
          // JSON.parse(document.querySelector('[name="properties[__midnight_config]"').value || null)

          let currentConfig = midnightConfig.value
            ? JSON.parse(midnightConfig.value)
            : {}

          currentConfig[key] = obj
          // Store in the midnight config field
          midnightConfig.value = JSON.stringify(currentConfig)

          // Construct the character preview url
          let pose_id = window.store.get('pose_id') || 'PZ001'
          let document_id = window.store.get('document_id') || 'DC001'
          let context_id = window.store.get('context_id') || 'CX001'
          let imageParams = [
            window.store.get('choiceUrl'),
            pose_id,
            document_id,
            context_id,
          ].join('_')
          let previewUrl = `https://builder.midnightplatform.net/midnight/system/generate/${imageParams}.png`
          // $('#preview').attr('src', previewUrl)

          // localStorage.setItem(genId(), JSON.stringify(currentConfig))

          // TODO: Remove this field as its not needed
          let midnightImage = document.getElementsByName(
            'properties[__midnight_image]'
          )[0]
          midnightImage.value = previewUrl

          // this assumes a single character thumbnail, not easy to convert to multiple
          // for each one - create a keyd holder to make it easier to use them throughout the site

          // Add image hidden input
          let image_holder = document.createElement('input')
          image_holder.type = 'text'
          image_holder.name = 'properties[__character_' + key + ']'
          image_holder.value = previewUrl
          // put it before the default input
          midnightImage.parentNode.insertBefore(image_holder, midnightImage)

          // Unlock page scroll
          $('html, body').removeClass('noScroll')
          // window.scrollTo(0, window.windowScrollPosition)
          document.scrollingElement.scrollTop = window.windowScrollPosition

          $('div.cBContainer').addClass('finished')

          characterStorage.characterSelected()

          $('#createCharacter').hide()
          $('#edit-character').show()

          // Close builder
          toggleBuilderWindow('none')
          $('.breadcrumbs').css('z-index', 2)
          $('.site-header').css('z-index', '')
          $('body').css('overflow', 'visible')

          checkIfAllCharactersAreCreated()

          // Store character preview

          window.store.set(key, previewUrl)
          window.save('')

          break
        case 'edit':
          // console.log("%c 👻 'edit' fired!", 'color: #d78521;')

          let baseUrl = 'https://builder.midnightplatform.net/midnight/system'
          let choiceUrl = event.data.data.choiceUrl

          // TODO: Get choices from cart data
          fetch(`${baseUrl}/get_choice_object.php?string=${choiceUrl}`)
            .then((res) => res.json())
            .then((res) => {
              let obj = buildMidnightConfigurationObject(
                event.data.data.brand,
                event.data.data.key,
                res.choices,
                choiceUrl
              )

              // Get hidden midnight config element
              let midnightConfig = document.getElementsByName(
                'properties[__midnight_config]'
              )[0]

              // FIXME: TypeError: Cannot read properties of undefined (reading 'value')
              let currentConfig = midnightConfig.value
                ? JSON.parse(midnightConfig.value)
                : {}

              currentConfig[event.data.data.key] = obj
              midnightConfig.value = JSON.stringify(currentConfig)

              // TODO: Remove this field as its not needed
              let midnightImage = document.getElementsByName(
                'properties[__midnight_image]'
              )[0]
              midnightImage.value = event.data.data.previewUrl

              // Add image hidden input
              let image_holder = document.createElement('input')
              image_holder.type = 'text'
              image_holder.name =
                'properties[__character_' + event.data.data.key + ']'
              image_holder.value = event.data.data.previewUrl
              // put it before the default input
              midnightImage.parentNode.insertBefore(image_holder, midnightImage)

              characterStorage.characterSelected()
            })
            .catch((err) => console.log(err))
          break
        case 'set':
          // console.log(
          //   "%c 👻 'set' fired! key: " + event.data.key,
          //   'color: #d78521;'
          // )
          if (event.data.key !== 'preview') {
            // console.log(`%c setting '${event.data.key}'`, 'color: #25ced1;')
            // console.log(`value: `, event.data.value)
          }
          window.store.set(event.data.key, event.data.value)
          break
        default:
          // console.log(
          //   "%c 👻 'default' fired! key: " + event.data.key,
          //   'color: #d78521;'
          // )
          window.store.set(event.data.key, event.data.value)
          break
      }
    }
  })
})

// Define beforeReady callback
window.Shoppad.apps.infiniteoptions.beforeReady = function (subscribe) {
  subscribe('appLoad', function () {
    fetchCart().then((data) => {
      localStorage.setItem('cart', JSON.stringify(data))
      loadProductOptionsFromCart()

      // If customer has characters show 'load character buttons'
      const chars = characterStorage.getAllCharacters()
      if (chars && chars.length > 0) {
        document.querySelectorAll('.load-character-button').forEach((el) => {
          el.classList.remove('hidden')
        })
      }
    })
    
    //Character Slots & Dates (Diary)
    init_multi_characters_dates()
  })
}

window.addEventListener('DOMContentLoaded', function () {
  console.log('🐻 DOMContentLoaded')
  characterStorage.initialiseCharacter()
})

function buildMidnightConfigurationObject(brand, key, choices, choiceUrl) {
  let data = {
    name: '',
    choices: choices || window.store.get('choices'),
    source: 'website',
    brand: brand || window.store.get('brand'),
    image: choiceUrl || window.store.get('choiceUrl'),
    pose_id: window.store.get('pose_id') || 'PZ001',
    document_id: window.store.get('document_id') || 'DC001',
    version: window.store.get('version') || 'v1.0',
    context_id: window.store.get('context_id') || 'CX001',
  }

  const itemAsString = JSON.stringify({
    brand: brand || window.store.get('brand'),
    character: choiceUrl || window.store.get('choiceUrl'),
  })

  //store in session
  sessionStorage.setItem(key, itemAsString)

  return data
}

function fetchCart() {
  return new Promise((resolve, reject) => {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((data) => resolve(data))
      .catch((err) => reject(err))
  })
}

/**
 * Fetch cart and populate product form fields with item props using item key
 * @returns void
 */
function loadProductOptionsFromCart() {
  console.log('🔥 loadProductOptionsFromCart')
  // Get item key from url params
  const itemKey = getParams(window.location.href)['key']

  if (!itemKey) return

  localStorage.setItem('itemKey', itemKey)

  const cartData = JSON.parse(localStorage.getItem('cart'))

  // const item = cartData.items.find((i) => i.key === itemKey)

  // Find item and store lineItemId to be used when Updating cart later
  const item = cartData.items.find((i, index) => {
    if (i.key === itemKey) {
      localStorage.setItem('lineItemId', index + 1)
      return true
    } else return false
  })

  if (!item) return

  // Get item props and quantity (only form fields)
  const formFields = { ...item.properties, quantity: item.quantity }

  for (const [key, value] of Object.entries(formFields)) {
    if (key === 'quantity') {
      document.getElementsByClassName('quantity-proxy')[0].value =
        parseInt(value)
      document.getElementById('Quantity').value = parseInt(value)
    }
    
    
    if (key.startsWith('__character_')) {
      const characterKey = key.replace('__character_', '')

      // Get choiceUrl from __midnigh_config[characterKey]
      const midnightConfig = JSON.parse(formFields.__midnight_config)
      const characterObject = midnightConfig[characterKey]
      console.log("characterObject", characterObject)
      let choiceUrl = characterObject.image
      let brand = characterObject.brand

      const { pose_id, document_id, context_id } = characterObject

      let baseUrl = 'https://builder.midnightplatform.net/midnight/system'
      let append = `${pose_id}_${document_id}_${context_id}.png`
      let previewUrl = `${baseUrl}/generate/${choiceUrl}_${append}`

      // Set character in global window.store object
      window.postMessage(
        {
          event: 'edit',
          data: { brand, key: characterKey, choiceUrl, previewUrl },
        },
        '*'
      )

      window.store.set(characterKey, value)
    
    }
    else if( key === "__Character Holder" ) // character slots (diary)
    {
		hydrate_multi_characters_dates(value)
    }
    
    
    // Update input values e.g. 'properties[Personal Text]'
    const el = document.querySelector(`[name="properties[${key}]"]`)
    if (el) el.value = value
  }

  // Show update UI stuff
  $('#add-to-cart').hide()
  $('#add-to-cart').prop('disabled', true)
  $('.update-buttons').show()
  window.save('')
}

function add_updated_item(formData) {
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    processData: false,
    contentType: false,
    dataType: 'json',
    data: formData,
    complete: function (data) {
      window.location = '/cart'
    },
  })
}

function trackAnalytics(action, label) {
  if (typeof ga != 'undefined') ga('send', 'event', action, label) //GA tracking
}

/**
 * getCurrentCharacterString
 * This function return the current choiceUrl combined witht the pose, document and context id
 */
function generateCharacterString(string) {
  let pose_id = window.store.get('pose_id') || 'PZ001'
  let document_id = window.store.get('document_id') || 'DC001'
  let context_id = window.store.get('context_id') || 'CX001'

  return [string, pose_id, document_id, context_id].join('_')
}

function getCurrentCharacterString() {
  let pose_id = window.store.get('pose_id') || 'PZ001'
  let document_id = window.store.get('document_id') || 'DC001'
  let context_id = window.store.get('context_id') || 'CX001'

  return [window.store.get('choiceUrl'), pose_id, document_id, context_id].join(
    '_'
  )
}

/**
 * savedCharacters()
 *
 * This function gets the users saved characters and passes them to the Moonshine
 * builder, which is then invoked to navigate to the saved character screen.
 */
function openSavedCharacters() {
  let moonshineConfig = JSON.parse(
    document.getElementById('moonshine_config_json').innerHTML
  )
  let sub_brand = []
  if (moonshineConfig.hide_subbrands) sub_brand = moonshineConfig.hide_subbrands

  let characters = characterStorage.getCharacters(
    moonshineConfig.brand,
    sub_brand
  )

  let contentWindow = document.getElementById(builderId).contentWindow

  contentWindow.postMessage({ event: 'characters', value: characters }, '*')
  contentWindow.postMessage({ event: 'navigate', key: 'selector' }, '*')
  openMoonshineDialog()

  trackAnalytics('Product Page', 'Opened Character List')
}

/**
 * openMoonshineDialog
 *
 * This function opens the Moonshine builder dialog
 */
function openMoonshineDialog() {
  window.windowScrollPosition = $(window).scrollTop()
  $('html, body').addClass('noScroll')
  toggleBuilderWindow('flex')
  $('.breadcrumbs').css('z-index', 1)
  $('.site-header').css('z-index', 1)
  $('body').css('height', '100%')
  $('body').css('overflow', 'hidden')
}

function closeMoonshineDialog() {
  $('html, body').removeClass('noScroll')
  // window.scrollTo(0, window.windowScrollPosition)
  document.scrollingElement.scrollTop = window.windowScrollPosition
  toggleBuilderWindow('none')
}

// // This function returns the current Moonshine builder config
// function getMoonshineConfig() {
//   return JSON.parse(
//     document.getElementById('moonshine_config_json').innerHTML,
//     null,
//     2
//   )
// }

// This function returns the current Midnight config for the product
//TODO Remove function
//Legacy function to get default Midnight config
function getMidnightConfig() {
  let data = {
    character1: {
      name: '',
      choices: window.store.get('choices'),
      source: 'website',
      brand: window.store.get('brand'),
      image: window.store.get('choiceUrl'),
      pose_id: window.store.get('pose_id') || 'PZ001',
      document_id: window.store.get('document_id') || 'DC001',
      version: window.store.get('version') || 'v1.0',
      context_id: window.store.get('context_id') || 'CX001',
    },
  }

  return JSON.stringify(data, null, 2)
}

function toggleBuilderWindow(property) {
  document.getElementById('moonshine_overlay').style.display = property
  document.getElementById('moonshine_dialog').style.display = property
}

function createCharacter(screen = 'builder', key = 'character1') {
  characterStorage.initialiseCharacter()

  let builderWindow = document.getElementById('builder').contentWindow

  builderWindow.postMessage({ event: 'navigate', key: screen }, '*')
  window.windowScrollPosition = $(window).scrollTop()
  document.scrollingElement.scrollTop = 0

  $('html, body').addClass('noScroll')
  toggleBuilderWindow('flex')
  $('.breadcrumbs').css('z-index', 1)
  $('.site-header').css('z-index', 1)
  $('body').css('height', '100%')
  $('body').css('overflow', 'hidden')

  ga('send', 'event', 'Product Page', 'Launch Builder') //GA tracking
  console.log('createCharacter')
}

/**
 * editCharacter
 *
 * This functional opens the builder for editing
 */
function editCharacter() {
  let builderWindow = document.getElementById('builder').contentWindow
  builderWindow.postMessage({ event: 'navigate', key: 'builder' }, '*')
  window.windowScrollPosition = $(window).scrollTop()
  // document.scrollingElement.scrollTop = 0
  $('html, body').addClass('noScroll')
  toggleBuilderWindow('flex')
  $('.breadcrumbs').css('z-index', 1)
  $('.site-header').css('z-index', 1)
  $('body').css('height', '100%')
  $('body').css('overflow', 'hidden')
}
